import React from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import PropTypes from "prop-types";
import classes from "./FeatureMoreInfoModal.module.scss";

const FeatureMoreInfoModal = ({
  t,
  show,
  onClose,
  data,
  columns,
  title,
  tableType,
}) => {
  if (!data) return null;

  return (
    <Modal
      show={show}
      onHide={onClose}
      size="lg"
      centered
      className={classes.featureMoreInfoModal}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {title || t("viewMoreInfo")}
          {data.id && <span className={classes.recordId}>#{data.id}</span>}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={classes.detailsContainer}>
          <Row>
            {columns.map((column) => (
              <Col key={column.key} xs={12} md={6} lg={4} className={classes.detailItem}>
                <div 
                  className={`${classes.detailItemContent} ${
                    tableType ? `modal-${tableType}-field-${column.key}` : ""
                  }`}
                >
                  <div className={classes.detailLabel}>{column.label}</div>
                  <div className={classes.detailValue}>
                    {column.render 
                      ? column.render(data) 
                      : data[column.key] === null || data[column.key] === undefined 
                        ? "-" 
                        : data[column.key]}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {t("close")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

FeatureMoreInfoModal.propTypes = {
  t: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  data: PropTypes.object,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      render: PropTypes.func,
    })
  ).isRequired,
  title: PropTypes.string,
  tableType: PropTypes.string,
};

export default FeatureMoreInfoModal;